import React from 'react';
import FormOne from '../contact/FormOne';
import Accordion from 'react-bootstrap/Accordion';
import { FaCompress, FaCode, FaGlobe } from 'react-icons/fa';


const AboutTwo = () => {
    return (
        <div className="section-padding">
            <div className="container">
            <div className="row">
                    <div className="col-lg-6">
                        <div className="why-choose-us">
                            <div className="section-heading heading-left">
                                <span className="subtitle">About Us</span>
                                <h3 className="title">We do design, code &amp; develop.</h3>
                                <p>At NewWay IT, we specialize in delivering cutting-edge technology solutions that empower businesses to thrive in a digital-first world. Our team combines innovation, expertise, and a customer-first approach to create tailored solutions that meet your unique needs.</p>
                            </div>
                            <Accordion defaultActiveKey="1">
                        <Accordion.Item eventKey="1">
                            <Accordion.Header><FaCompress /> Strategy</Accordion.Header>
                            <Accordion.Body>
                            We focus on creating tailored strategies that align with your unique business goals. By combining cutting-edge technology with industry expertise, we deliver solutions that drive efficiency, scalability, and innovation for your software needs.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header><FaCode /> Design</Accordion.Header>
                            <Accordion.Body>
                            Our design philosophy centers on creating intuitive and visually appealing interfaces. By prioritizing user experience, we ensure that every interaction with our software is both engaging and efficient, leaving a lasting impression.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header><FaGlobe /> Development</Accordion.Header>
                            <Accordion.Body>
                            Our development process is driven by innovation and precision. We leverage the latest technologies to create software that is robust, scalable, and tailored to meet the evolving needs of your business.
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6 offset-xl-1">
                        <div className="contact-form-box shadow-box mb--30">
                            <h3 className="title">Get a free Keystroke quote now</h3>
                            <FormOne />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutTwo;